import TCSegmentsCollectionUIModel from './tc-segments-collection.js';

class TCBookedLegUIModel {
  constructor({
    fareFamily = '',
    legCode = '',
    legEntity = '',
    legRegion = '',
    remainingTimeToCheckin = null,
    remainingTimeToDeparture = null,
    remainingTimeToDocuments = null,
    segments = [],
    totalFlightDuration = null,
    windowLegStatus = '',
  } = {}) {
    this.fareFamily = fareFamily;
    this.legCode = legCode;
    this.legEntity = legEntity;
    this.legRegion = legRegion;
    this.remainingTimeToCheckin = remainingTimeToCheckin;
    this.remainingTimeToDeparture = remainingTimeToDeparture;
    this.remainingTimeToDocuments = remainingTimeToDocuments;
    this.segmentsCollection = new TCSegmentsCollectionUIModel(segments);
    this.totalFlightDuration = totalFlightDuration;
    this.windowLegStatus = windowLegStatus;
  }
}

export default TCBookedLegUIModel;